import { Base2Presenter } from "core/presenter";
import { OrderIntegration, CompanyRepository } from "core/repository";
class OrderIntegrations extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      errors: "",
      data: [],
      paymentData: [],
      companyUuid: ""
    };
  }
  onStart() {
    this.load();
  }

  async loadPayments() {
    const currentUser = await this.mRuntime.get("currentUser");
    const paymentsResult = await CompanyRepository.getOnline(
      currentUser.company_uuid
    );
    if (paymentsResult.success) {
      this.enqueue({
        paymentData: paymentsResult.data.custom_other_payments || []
      });
    }
  }

  async load() {
    const companyUuid = this.routeParams.companyUuid;

    this.enqueue({ loading: !!companyUuid, companyUuid });

    if (!companyUuid) return;

    const result = await OrderIntegration.getOrderIntegration(companyUuid);

    this.loadPayments();
    if (result.success) {
      this.enqueue({ data: result.data });
    } else {
      this.sendAlert({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }

  resetErrors(editing) {
    if (editing) return

    this.enqueue({ errors: "" })
  }

  async postForm(form) {
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = this.routeParams.companyUuid;

    form = {
      ...form,
      company_uuid: companyUuid,
      account_uuid: currentUser.account_uuid
    };

    return await OrderIntegration.postOrderIntegration(form);
  }

  async updateForm(form, uuid) {
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = this.routeParams.companyUuid;

    form = {
      ...form,
      company_uuid: companyUuid,
      account_uuid: currentUser.account_uuid
    };
    return await OrderIntegration.updateOrderIntegration(form, uuid);
  }

  validForm(form) {
    let errors = {}

    for (let field in form) {
      if(form[field] === "") {
        errors[field] = "Campo Obrigatório"
      }
    }

    return { errors: errors, valid: Object.keys(errors).length === 0 }
  }

  async onSave(form, editing, uuid, modal) {
    const validationResult = this.validForm(form);

    if (validationResult.valid) {
      const response = editing ? await this.updateForm(form, uuid) : await this.postForm(form);
      const successMessage = editing ? "Atualização realizada com sucesso!" : "Integração feita com sucesso!"
      const errorMessage = "Ocorreu um erro durante a criação da integração"

      this.notificateUser(response, successMessage, errorMessage)
      modal();
    } else {
      this.enqueue({ errors: validationResult.errors })
    }

    this.load();
  }

  async onSaveEnabled(form) {
    const response = await OrderIntegration.updateOrderIntegration(form, form.uuid);
    const successMessage = form.enabled ? "Integração habilitada com sucesso!" : "Integração desabilitada com sucesso!"
    const errorMessage = "Não conseguimos ativar/desativar essa integração! Tente novamente em alguns minutos."

    this.notificateUser(response, successMessage, errorMessage)
    this.load();
  }

  notificateUser(response, successMessage, errorMessage) {
    response.success
      ? this.sendAlert({
          type: "success",
          content: successMessage
        })
      : this.sendAlert({
          type: "error",
          title: "Oops...",
          content: errorMessage
        })
  }

  sendAlert({ type, title, content }) {
    this.sendNotification({
      type: type,
      title: title,
      content: content
    });
  }
}

export default OrderIntegrations;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/order_integrations/presenter.js